<template>
  <div v-if="companies && companies.length > 0" class="clients-slider font-grotesque">
    <div class="container swiper-buttons">
      <div class="col-md-4 swiper-big-button-wrap">
        <div class="swiper-big-button-prev" slot="button-prev">
          <img v-if="dark" class="switcher--arrow" src="/static/arrow-left-white.svg"/>
          <img v-else class="switcher--arrow" src="/static/arrow-left-dark.svg"/>
        </div>
        <div class="swiper-big-button-next" slot="button-next">
          <img v-if="dark" class="switcher--arrow" src="/static/arrow-right-white.svg"/>
          <img v-else class="switcher--arrow" src="/static/arrow-right-dark.svg"/>
        </div>
      </div>
    </div>

    <div class="swiper-main">
      <swiper ref="swip" :options="swiperOption">
        <swiper-slide v-for="(company, key) in slides" :key="company.$id">
          <div @click.prevent="switchPopup(key)" class="swiper-slide-wrap">
            <div class="swiper-slide-col col-md-8 font-antique">

              <div v-html="company.text.item[lang].main_content"/>
            </div>
            <div class="company-info col-md-3">
              <div class="company-info-person">
                <div v-if="company.text.item[lang].main_content_short" class="font-antique company-info-name" v-html="company.text.item[lang].main_content_short"/>

                <p v-if="company.text.item[lang].$position" class="comment">{{ company.text.item[lang].$position }}</p>
              </div>

              <img class="company-info-logo" v-if="company.logo" :src="company.logo.$src"/>
              <p class="font-antique company-info-company" v-else>{{ company.text.item[lang].$title }}</p>

            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <Slider v-if="slides.length" :slides="slides" :dark="dark"/>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Slider from '@/components/Slider';
import filterCompanies from '@/helpers/filterCompanies';

require('@/assets/css/swiper.css');

export default {
  name: 'sliderBig',
  computed: mapGetters({
    companies: 'companies',
    popup: 'popup',
    lang: 'lang',
  }),
  components: {
    Slider,
  },
  props: ['dark'],
  mounted() {
    this.$store.dispatch('fetchCompanies');
  },
  watch: {
    companies() {
      if (this.companies && this.companies.length && this.slides.length === 0) {
        this.slides = this.fetchSliderCompanies();
      }
    },
  },
  data() {
    return {
      slide: 0,
      slides: [],
      swiperOption: {
        direction: 'horizontal',
        speed: 500,
        loop: true,
        paginationClickable: true,
        keyboardControl: true,
        centeredSlides: true,
        preventClicks: false,
        autoHeight: true,
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 30,
        navigation: {
          nextEl: '.swiper-big-button-next',
          prevEl: '.swiper-big-button-prev',
        },
      },
    };
  },
  methods: {
    fetchSliderCompanies() {
      return filterCompanies(this.companies, this.dark, this.lang);
    },

    switchPopup(slide) {
      let current = slide - 1;
      if (current === this.slides.length) current = 0;
      else if (current > this.slides.length) current = 0;
      else if (current < 0) current = this.slides.length - 1;

      if (this.slides && this.slides.length && this.slides[current]) {
        const slug = this.slides[current].$slug;
        this.openPopup(slug);
      }
    },

    openPopup(slug) {
      this.$store.commit('FETCH_COMPANY', slug);
      this.$store.dispatch('popupState', true);
    },
  },
};
</script>

<style>
.page{
  &-clients{
    .page-front &{
      overflow: hidden;
    }
    h1{
      position: relative;
      z-index: 999;
    }
    .swiper{

      &-buttons{
        @media (max-width: $mediaMini) {
          display: none;
        }
      }

      &-big-button{
        &-wrap{
          width: 100px;
          height: 40px;
          float: right;
          z-index: 999;
          top: -90px;

          @media (min-width: $mediaSmallScreen) {
            right: -60px;
          }

          @media (min-width: $mediaIpad) and (max-width: $mediaSmallScreen) {
            right: -100px;
          }

          @media (max-width: $mediaIpad) {
            top: -65px;
          }
        }

        &-prev{
          position: relative;
          float: left;
          top: -1px;

          .switcher--arrow{
            transform: rotateZ(180deg) translate3d(0,1px,0);
            display: block;
          }
        }

        &-prev,
        &-next{
          transition: all .3s ease-in-out;
          transform-origin: center center;
          background: none;
          cursor: pointer;
          z-index: 99;
          outline: 0;
          left: 0;
          top: 0;

          &:hover{
            transform: scale(1.2);
          }
          @media (max-width: $mediaMob) {
            display: none;
          }
        }

        &-next{
          float: right;
          left: 50px;
        }
      }
    }

    .swiper-main {
      @media (max-width: $mediaMini) {
        display: none;
      }
      .swiper{

        &-container{
          margin-left: -80px;
          min-height: 250px;
          overflow: visible;
        }
        &-buttons{
          position: relative;
          z-index: 999;
        }

        &-slide{
          transition: opacity .3s ease-in-out;
          max-width: 100%;

          &-wrap{
            transition: transform 600ms cubic-bezier(0.555, 0.150, 0.170, 1.050);
            padding: 45px 0px 50px 45px;
            transform: skewX(-8deg);
            border: solid 1px #ccc;
            max-width: 1000px;
            overflow: hidden;
            margin: 0 auto;
            width: 100%;


            @media (max-width: $mediaLaptop){
              padding-bottom: 30px;
              padding-top: 30px;
            }
            .page-theme-dark &{
              border-color: rgba(255, 255, 255, 0.5);
            }

            &:hover{
              transform: scale(1.02) skewX(-8deg);
            }


            & > *{
              transform: skewX(8deg);
            }
          }

          p{
            max-width: 95%;
          }

          &-col{
            font-size: 140%;

            @media (min-width: $mediaLaptop){
              /*margin-left: 50px;*/
            }

            @media (max-width: $mediaLaptop){
              font-size: 100%;
            }
          }

          &,
          &-prev,
          &-next{
            opacity: .4;
          }

          &-active{
            opacity: 1;
          }

          &-text{
            max-width: 100%;
          }
        }
      }

      .company{
        &-info{
          margin-top: 10px;

          @media (max-width: $mediaMob) {
            margin: 0 15px;

            .company-info-person,
            .company-info-logo{
              display: inline-block;
              vertical-align: middle;
            }

            .company-info-person{
              min-width: 200px;
              max-width: 60%;
            }
          }

          @media (max-width: $mediaMini) {
            /*margin-left: 0;*/
          }

          .comment{
            position: relative;
            margin-top: 2px;
            display: block;
            opacity: 0.6;
            z-index: 999;
          }

          &-name{
            p{
              margin: 10px 0 2px;
            }
          }
          &-company{
            opacity: 0.6;
            @media (max-width: $mediaLaptop){
              font-size: 90%;
            }
          }

          img{
            width: 100px;

            .app-mozilla &,
            .app-safari &,
            .app-chrome & {
              max-width: 140px;
              min-width: 50px;
              width: auto;
            }

            @media (max-width: $mediaLaptop){
              max-height: 100px;
            }
            @media (max-width: $mediaMob) {
              max-width: 100px;
            }
          }
        }
      }
    }
  }

  &.page-dark .swiper-main {
    position: relative;
    right: -50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SliderBig.vue